import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { FuseSharedModule } from '@fuse/shared.module';
import { NgxMaskModule } from 'ngx-mask';
import { UnregisteredNewComponent } from 'app/main/unregistered-new/unregistered-new.component';
import { UnregisteredNewService } from 'app/main/unregistered-new/unregistered-new.service';
import { FlexLayoutModule } from '@angular/flex-layout';

const routes = [
  {
    path: "unregistered-new",
    component: UnregisteredNewComponent,
  },
];

@NgModule({
  declarations: [UnregisteredNewComponent],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    TranslateModule,
    MatButtonModule,
    FuseSharedModule,
    MatTableModule,
    MatIconModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    NgxMaskModule,
    MatAutocompleteModule,
    FlexLayoutModule
  ],
  exports: [UnregisteredNewComponent],
  providers: [UnregisteredNewService]
})
export class UnregisteredNewModule { }
